import { __extends } from "tslib";
import { Debug } from '@awayjs/core';
import { EventDispatcher } from '../events/EventDispatcher';
// Class: NativeMenuItem
var NativeMenuItem = /** @class */ (function (_super) {
    __extends(NativeMenuItem, _super);
    function NativeMenuItem() {
        var _this = _super.call(this) || this;
        _this._enabled = true;
        return _this;
    }
    Object.defineProperty(NativeMenuItem.prototype, "enabled", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/display/NativeMenuItem', 'get enabled', '');
            return this._enabled;
        },
        set: function (isSeparator) {
            isSeparator = !!isSeparator;
            // @todo
            Debug.throwPIR('playerglobals/display/NativeMenuItem', 'set enabled', '');
            this._enabled = isSeparator;
        },
        enumerable: true,
        configurable: true
    });
    // Called whenever the class is initialized.
    NativeMenuItem.classInitializer = null;
    // List of static symbols to link.
    NativeMenuItem.classSymbols = null; // [];
    // List of instance symbols to link.
    NativeMenuItem.instanceSymbols = null; // [];
    return NativeMenuItem;
}(EventDispatcher));
export { NativeMenuItem };
